"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.outputToConsole = void 0;
var browser_1 = require("./browser");
function styleString(style) {
    return Object.entries(style).reduce(function (styleString, _a) {
        var propName = _a[0], propValue = _a[1];
        propName = propName.replace(/[A-Z]/g, function (match) { return "-".concat(match.toLowerCase()); });
        return "".concat(styleString).concat(propName, ":").concat(propValue, ";");
    }, '');
}
var groupDepth = 0;
function finn(method) {
    var data = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        data[_i - 1] = arguments[_i];
    }
    if ((0, browser_1.isSupported)() === false) {
        console[method].apply(console, data);
        return;
    }
    if (method === 'trace' && (0, browser_1.isFirefox)()) {
        console[method].apply(console, data);
        return;
    }
    var short = groupDepth > 0;
    if (method === 'group') {
        groupDepth++;
    }
    if (method === 'groupCollapsed') {
        groupDepth++;
    }
    if (method === 'groupEnd') {
        groupDepth--;
    }
    var message = '';
    var optionalParams = [];
    if (data.length) {
        var first = data[0], rest = data.slice(1);
        if (first && typeof first === 'string') {
            message = first;
            optionalParams = rest;
        }
        else {
            short = true;
            optionalParams = data;
        }
    }
    var primary = '#0063FB';
    var secondary = '#06BEFB';
    var text = '#ffffff';
    if (method === 'error') {
        primary = '#D9270A';
        secondary = '#FF5844';
    }
    if (method === 'warn') {
        primary = '#FFE470';
        secondary = '#FFF5CB';
    }
    if (method === 'debug') {
        primary = '#2EE69F';
        secondary = '#CCFFEC';
    }
    if (method === 'log') {
        primary = '#C3CCD9';
        secondary = '#F6F8FB';
    }
    var border = "2px solid ".concat(text);
    var finnLogoBase = {
        color: text,
        fontFamily: 'sans-serif',
        fontWeight: 'bold',
        lineHeight: 1.8,
        paddingTop: '1px',
    };
    var finnLogoLeft = __assign(__assign({}, finnLogoBase), { background: primary, border: border, borderRadius: '3px 16px 3px 3px', paddingRight: '12px', paddingLeft: '6px', marginRight: '-1px' });
    var finnLogoRight = __assign(__assign({}, finnLogoBase), { background: secondary, border: border, borderRadius: '3px 3px 3px 3px', paddingRight: '12px', paddingLeft: '6px', marginRight: '5px', marginLeft: '-1px' });
    var finnLogoRightStart = __assign(__assign({}, finnLogoBase), { background: secondary, border: border, borderRight: 'none', borderRadius: '3px 0px 0px 3px', paddingRight: '0px', paddingLeft: '2px', marginLeft: '-1px' });
    var finnLogoLetter = __assign(__assign({}, finnLogoBase), { background: secondary, borderTop: border, borderBottom: border, paddingRight: '1px', paddingLeft: '1px' });
    var finnLogoRightStop = __assign(__assign({}, finnLogoBase), { background: secondary, border: border, borderLeft: 'none', borderRadius: '0px 3px 3px 0px', paddingRight: '2px', paddingLeft: '0px', marginRight: '5px' });
    var reset = {};
    if (short) {
        console[method].apply(console, __spreadArray(["%c %c %c".concat(message), styleString(finnLogoLeft),
            styleString(finnLogoRight),
            styleString(reset)], optionalParams, false));
    }
    else {
        console[method].apply(console, __spreadArray(["%c %c %cF%cI%cN%cN%c %c".concat(message), styleString(finnLogoLeft),
            styleString(finnLogoRightStart),
            styleString(finnLogoLetter),
            styleString(finnLogoLetter),
            styleString(finnLogoLetter),
            styleString(finnLogoLetter),
            styleString(finnLogoRightStop),
            styleString(reset)], optionalParams, false));
    }
}
function outputToConsole(method) {
    var data = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        data[_i - 1] = arguments[_i];
    }
    switch (method) {
        case 'debug':
        case 'error':
        case 'group':
        case 'groupCollapsed':
        case 'groupEnd':
        case 'log':
        case 'info':
        case 'warn':
        case 'trace':
        case 'debug':
            finn.apply(void 0, __spreadArray([method], data, false));
            break;
        case 'assert':
            console.assert.apply(console, data);
            break;
        case 'clear':
            console[method]();
            break;
        case 'count':
        case 'countReset':
        case 'dir':
        case 'dirxml':
        case 'table':
        case 'time':
        case 'timeEnd':
        case 'timeLog':
            console[method].apply(console, data);
            break;
        default:
            break;
    }
}
exports.outputToConsole = outputToConsole;
